if (!customElements.get('wlsn-blog-featured')) {
  class WLSNBlogFeatured extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        articlesWrapper: 'js-wlsn-blog-featured-articles',
        slidesWrapper: 'js-wlsn-blog-featured-articles-slides',
        wlsnSlider: 'wlsn-slider',
      };

      this.bindMethods = {
        init: this._init.bind(this),
        destroy: this._destroy.bind(this),
        handleResize: this._handleResize.bind(this),
      };

      this.resizeTimeout = null;
    }

    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        articlesWrapper: this.querySelector(`.${this.classes.articlesWrapper}`),
        slidesWrapper: this.querySelector(`.${this.classes.slidesWrapper}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      // Wait for all custom elements to be defined before initializing
      this._waitForSliderDefinition().then(() => {
        this.bindMethods.init();
      });
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.bindMethods.destroy();
    }

    /**
     * Wait for slider custom element to be defined
     * @returns {Promise<void>}
     */
    async _waitForSliderDefinition() {
      // Wait for wlsn-slider custom element to be defined
      if (customElements.get(this.classes.wlsnSlider)) {
        return Promise.resolve();
      }

      return customElements.whenDefined(this.classes.wlsnSlider);
    }

    /**
     * Initialize component
     * @returns {void}
     */
    _init() {
      // Execute moveArticles immediately before slider initialization
      this._moveArticles();

      // Add resize listener
      window.addEventListener('resize', this.bindMethods.handleResize);
    }

    /**
     * Cleanup and destroy component
     * @returns {void}
     */
    _destroy() {
      window.removeEventListener('resize', this.bindMethods.handleResize);
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }

    /**
     * Handle window resize event
     * @returns {void}
     */
    _handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => {
        this._moveArticles();
      }, 150);
    }

    /**
     * Move articles between desktop and mobile layouts
     * @returns {void}
     */
    _moveArticles() {
      const { articlesWrapper, slidesWrapper } = this.elements;

      if (!articlesWrapper || !slidesWrapper) return;

      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Move all articles from desktop to mobile slider
        const articles = articlesWrapper.children;

        // Check if there are already slides in the mobile container
        if (slidesWrapper.children.length === 0 && articles.length > 0) {
          Array.from(articles).forEach((article) => {
            slidesWrapper.appendChild(article.cloneNode(true));
          });

          // Wait for DOM to update, then wait for slider to initialize, then trigger reinit
          setTimeout(() => {
            const wlsnSlider = this.querySelector(`.${this.classes.wlsnSlider}`);
            if (wlsnSlider) {
              // Dispatch custom event to trigger slider initialization/reinit
              const event = new CustomEvent('wlsn:slider:reinit', { bubbles: true });
              wlsnSlider.dispatchEvent(event);
            }
          }, 100);
        }
      } else {
        // Clear mobile slider if it exists
        if (slidesWrapper.children.length > 0) {
          slidesWrapper.innerHTML = '';
        }
      }
    }
  }

  customElements.define('wlsn-blog-featured', WLSNBlogFeatured);
}
